<div class="flex flex-col flex-auto min-w-0 mx-auto">
    <!-- Header -->
    <div class="bg-card dark:bg-default bg-gradient-to-tr dark:from-primary-950 from-primary-100 from-0%  via-transparent via-80%" >
        <div class="flex flex-col w-full mx-auto px-6 sm:px-8">
            <div class="flex flex-col sm:flex-row flex-auto sm:items-center min-w-0 my-8 sm:my-2">
                <!-- Avatar and name -->
                <div class="flex flex-auto items-center min-w-0">
                    <div class="flex flex-col min-w-0 ml-4 my-5">
                        <div class="flex flex-auto items-center min-w-0">
                            <mat-icon
                                class="icon-size-12 md:icon-size-18"
                                [svgIcon]="'heroicons_solid:at-symbol'"></mat-icon>
                            <div class="flex flex-col min-w-0 ml-4">
                                <ng-container *transloco="let t">
                                    <div class="text-2xl md:text-5xl font-semibold tracking-tight leading-7 md:leading-snug truncate">{{t('Contact')}}</div>
                                </ng-container>
                                <div class="flex items-center">
                                    <div class="ml-1.5 leading-6 truncate text-secondary md:text-xl">
                                        {{ 'Ia legatura cu noi' | transloco}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Actions -->
                <div class="flex flex-col items-stretch mt-5 space-y-3">
                    <div class="hidden sm:flex sm:flex-col items-center p-2 bg-card shadow-md w-50 rounded-md">
                        <div  class="p-4 bg-gradient-to-bl from-transparent from-0% dark:via-primary-900 via-primary-100 via-40%">
                            <img class="rounded-sm w-full mb-5" src="assets/images/logo/logo.svg" alt="Smiles Manager logo">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Content-->
    <div class="flex flex-col justify-center p-8 bg-card shadow rounded-2xl m-8">
        <div class="text-2xl text-left font-bold w-full">Daca ai nevoie de mai multe informații sau vrei să ne transmiți părerea ta, nu ezita să ne scrii!</div>
        <div class="flex flex-col sm:flex-row gap-4">
            <div class="flex flex-col w-full mt-4">
                <div class="text-primary text-lg font-bold">Date despre firma</div>
                <div class="text-secondary">S.C. SRP SW Solutions S.R.L.</div>
                <div class="text-secondary">Jud. Sibiu, Selimbar</div>
                <div class="text-secondary">Adresa: Str. Doamna Stanca 59 Bl. 2 Et. P Ap. 5 Cod 557260</div>
                <div class="text-secondary">CUI: RO46568980</div>
                <div class="text-secondary">J32/1587/2022</div>
            </div>
            <div class="flex flex-col w-full mt-4">
                <div class="text-primary text-lg font-bold">Date de contact</div>
                <div class="text-secondary">Tel: +40 750 248 928 </div>
                <div class="text-secondary">Email: contact&#64;smilesmanager.ro </div>
                <div class="text-secondary">Web: <a href="http://www.smilesmanager.ro">www.smilesmanager.ro</a></div>
            </div>
        </div>


        <div class="flex flex-col sm:flex-row justify-center gap-3 ml-4 mt-12 w-full">
            <div class="w-fit">
                <a href="https://netopia-payments.com/" target="_blank" rel="noopener">
                    <img src="../../../../assets/images/ui/smm/footer/netopia.png" alt="Solutionare Litigii" class="h-12">
                </a>
            </div>
            <div class="w-fit">
                <a href="https://anpc.ro" target="_blank" rel="noopener">
                    <img src="../../../../assets/images/ui/smm/footer/anpc.jpg" alt="ANPC SAL" class="h-12">
                </a>
            </div>
            <div class="w-fit">
                <a href="https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home2.show&lng=RO" target="_blank" rel="noopener">
                    <img src="../../../../assets/images/ui/smm/footer/solutionare_litigii.jpg" alt="Solutionare Litigii" class="h-12">
                </a>
            </div>
        </div>

        <hr class="my-8">

        <div class="flex flex-row w-full place-content-center ">
            <button mat-flat-button color="primary" class="rounded-lg my-auto"  [routerLink]="'../'">
                <mat-icon svgIcon="mat_outline:home"></mat-icon>
                Acasa
            </button>
        </div>

    </div>




</div>
